module.exports = __webpack_public_path__ + "static/media/logo-word-yellow.1e6dcce3.svg";